import React from 'react'
import { DocumentTextIcon, XMarkIcon } from "@heroicons/react/24/outline";

const FilePreview = ({fileName, fileSizeText, removeFile}) => {
  if (!fileName) return null;
  return (
    <div className="flex items-center justify-between p-3 mt-3 mb-4 border rounded-lg bg-white shadow-sm">
          <div className="flex items-center gap-3">
            <DocumentTextIcon className="w-5 h-5 text-gray-600" />
            <div>
              <div className="text-sm font-medium text-gray-900">{fileName}</div>
              <div className="text-xs text-gray-500">{fileSizeText}</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="p-1 rounded hover:bg-gray-100"
              aria-label="Remove file"
              onClick={removeFile}
            >
              <XMarkIcon className="w-5 h-5 text-gray-500" />
            </button>
          </div>
        </div>
  )
}

export default FilePreview
